import { buildMarketplaceOwnerReportingUri } from 'utils/routes';

const OWNER_REPORTING_CODE = 'owner-reporting';

const getSubscriptionHostId = sub => {
  if (!sub || !sub.host) return undefined;
  if (typeof sub.host === 'object') return sub.host._id ? String(sub.host._id) : undefined;
  return String(sub.host);
};

export const isOwnerReportingActiveSub = sub =>
  !!(sub && sub.productCode === OWNER_REPORTING_CODE && sub.status === 'active');

export const getOwnerReportingActiveHostIds = (subscriptions = []) => {
  const ids = {};
  (subscriptions || []).forEach(sub => {
    if (!isOwnerReportingActiveSub(sub)) return;
    const hostId = getSubscriptionHostId(sub);
    if (hostId) ids[hostId] = true;
  });
  return Object.keys(ids);
};

export const shouldHideV1OwnerPages = ({ userHostIds = [], subscriptions = [], isAdmin = false } = {}) => {
  if (isAdmin) return false;
  const hosts = (userHostIds || []).map(String).filter(Boolean);
  if (!hosts.length) return false;
  const activeSet = {};
  getOwnerReportingActiveHostIds(subscriptions).forEach(id => {
    activeSet[id] = true;
  });
  return hosts.every(id => activeSet[id]);
};

export const shouldRedirectV1Host = ({ hostId, subscriptions = [], isAdmin = false } = {}) => {
  if (isAdmin) return false;
  if (!hostId) return false;
  const activeSet = {};
  getOwnerReportingActiveHostIds(subscriptions).forEach(id => {
    activeSet[String(id)] = true;
  });
  return !!activeSet[String(hostId)];
};

export const shouldShowOwnerPayoutV2 = ({ isOwner, hostId, userHostIds = [], subscriptions = [] } = {}) => {
  if (!isOwner) return false;
  const selected = hostId || (userHostIds && userHostIds[0]);
  return shouldRedirectV1Host({ hostId: selected, subscriptions });
};

export const buildOwnerReportingV1RedirectTo = ({ pathname, hostId } = {}) => {
  const path = String(pathname || '');
  let subpath = 'dashboard';
  if (path.indexOf('/servicepackage') === 0) {
    subpath = 'service-packages';
  } else if (path.indexOf('/expenses') === 0) {
    subpath = 'expenses';
  } else if (path.indexOf('/payout') === 0) {
    subpath = 'installments';
  }

  const base = buildMarketplaceOwnerReportingUri(subpath);
  if (!hostId) return base;
  return `${base}?hostId=${encodeURIComponent(hostId)}`;
};
